/**
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 **/
import React, { ReactElement, ReactNode, useEffect } from 'react';
import { gql, useQuery } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { Language } from '@userzoomplatform/pe-i18n';

import i18n, { Namespaces } from '../../utils/i18n';
import { getHtmlTabTitleKey } from '../../utils/constants';
import { CustomizationQueryResponse } from '../../types/customization';

import { inIframe } from '../../utils/iframe';

type Props = {
	children: ReactNode;
};

export const customizationQuery = gql`
	query customization {
		customization {
			language
		}
	}
`;

const Main = ({ children }: Props): ReactElement => {
	const { t } = useTranslation(Namespaces.Common);
	const location = useLocation();

	const {
		called: calledCustomization,
		loading: loadingCustomization,
		data: customizationData,
	} = useQuery<CustomizationQueryResponse>(customizationQuery);

	useEffect(() => {
		if (calledCustomization && !loadingCustomization) {
			const language = new Language(i18n);
			language.onResourcesLoaded(() => {
				document.dir = language.getDirection();
			});
			language.setLanguage(customizationData?.customization?.language);
		}
	}, [calledCustomization, loadingCustomization, customizationData]);

	useEffect(() => {
		if (inIframe) {
			const element = document.getElementById('root');
			if (element) {
				element.style.height = '100%';
			}
		} else {
			document.title = t(getHtmlTabTitleKey(location.pathname.replace('/', '')));
		}
	}, [t, location.pathname]);

	const style = inIframe ? { height: '100%' } : {};

	return <div style={style}>{children}</div>;
};

export default Main;
